// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Loader-styles___loaderLayout--PX9Qt {
  text-align: center;
  position: relative;
}

  .components-Loader-styles___loaderLayout--PX9Qt .components-Loader-styles___s-circular-progress--yKZlf {
    position: absolute;
    top: 30px;
  }
`, "",{"version":3,"sources":["webpack://./components/Loader/styles.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AAMpB;;EAJE;IACE,kBAAkB;IAClB,SAAS;EACX","sourcesContent":[".loaderLayout {\n  text-align: center;\n  position: relative;\n\n  .s-circular-progress {\n    position: absolute;\n    top: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderLayout": `components-Loader-styles___loaderLayout--PX9Qt`,
	"sCircularProgress": `components-Loader-styles___s-circular-progress--yKZlf`
};
module.exports = ___CSS_LOADER_EXPORT___;
